module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-backplates-remnants.c344070a.png";